import React from "react";
import { useSelector } from "react-redux";
import { Skeleton } from "antd";
import { useState, useEffect } from "react";
import useRunCompare from "../../../hooks/insights/useRunCompare"
import InsightsError from "./InsightsError";
import InsightsDetails from "./InsightsDetails";
import VersusComponent from "./VersusComponent";

function CompareDetails({ language }) {
    const {
        isLoading, details, isError, setRerun
    } = useRunCompare(language);

    const [compare1Result, setCompare1Result] = useState("");
    const [compare2Result, setCompare2Result] = useState("");
    const [compareResult, setCompareResult] = useState("");
    const {
        compare1, compare2
    } = useSelector((state) => state.insights);

    const getContent = () => {
        if (isLoading) return <Skeleton paragraph={{ rows: 4 }} active />;
        return compareResult;
    };
    useEffect(() => {
        if (details) {
            try {
                const [inputText, resultText] = details.replace(/Analysis :/g, "Analysis:").split("Comparison:");
                const [temp, text1, text2] = inputText.split("Analysis:");
                setCompare1Result(text1.split("Input:")[0].trim());
                setCompare2Result(text2.trim());
                setCompareResult(resultText.trim());
            } catch (error) {
                setCompare1Result("");
                setCompare2Result("");
                setCompareResult(details.trim());
            }
        }
    }, [details]);

    return (
        <div className="report--insights--comparedetails d-flex-col gap-1">
            {(isError)
                ? <InsightsError show={isError} setRerun={setRerun} /> : (
                    <>
                        <div className="d-flex align-items-center" style={{ background: "white", borderRadius: "5px" }}>
                            {compare1 && (
                                <InsightsDetails
                                    data={compare1}
                                    withTitle
                                    customDetails={{
                                        isLoading,
                                        details: compare1Result
                                    }}
                                />
                            )}
                            <VersusComponent />
                            {compare2 && (
                                <InsightsDetails
                                    data={compare2}
                                    withTitle
                                    position="left"
                                    customDetails={{
                                        isLoading,
                                        details: compare2Result
                                    }}
                                />
                            )}
                        </div>
                        <div style={{
                            padding: "5mm", background: "white", borderRadius: "5px"
                        }}
                        >
                            <div className="d-flex justify-content-center">
                                <span className="report--insights--details--title with-bottom-border">Comparison</span>
                            </div>
                            <p className="report--insights--details--compparagraph">
                                {getContent()}
                            </p>
                        </div>
                    </>
                )}

        </div>
    );
}

export default CompareDetails;
